import { gql } from '@apollo/client';
import list from './List';
import create from './Create';
import show from './Show';

export default {
  name: 'ProfessionalPositions',
  inputShow: gql`
    query professionalPositions($input: ProfessionalPositionQueryInput) {
      professionalPositions(input: $input) {
        id
        __typename
      }
    }
  `,
  list,
  show,
  create,
  options: {
    group: 'Misc',
    label: 'Professional Positions',
  },
};
